<template>
  <div v-show="isbealter" class="bealter">
    <div class="bag" @click="hideBealter"></div>
    <div class="cont">
      <div class="close" @click="hideBealter">
        <svg
          t="1668155870681"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2131"
          width="30"
          height="30"
        >
          <path
            d="M511.333 127.333c51.868 0 102.15 10.144 149.451 30.15 45.719 19.337 86.792 47.034 122.078 82.321 35.287 35.286 62.983 76.359 82.321 122.078 20.006 47.3 30.15 97.583 30.15 149.451s-10.144 102.15-30.15 149.451c-19.337 45.719-47.034 86.792-82.321 122.078-35.286 35.287-76.359 62.983-122.078 82.321-47.3 20.006-97.583 30.15-149.451 30.15s-102.15-10.144-149.451-30.15c-45.719-19.337-86.792-47.034-122.078-82.321-35.287-35.286-62.983-76.359-82.321-122.078-20.006-47.3-30.15-97.583-30.15-149.451s10.144-102.15 30.15-149.451c19.337-45.719 47.034-86.792 82.321-122.078 35.286-35.287 76.359-62.983 122.078-82.321 47.301-20.006 97.583-30.15 149.451-30.15m0-64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448z"
            fill="#757e8d"
            p-id="2132"
          />
          <path
            d="M557.254 512l147.373-147.373c12.497-12.497 12.497-32.758 0-45.255-12.496-12.497-32.758-12.497-45.254 0L512 466.746 364.627 319.373c-12.497-12.497-32.758-12.497-45.255 0s-12.497 32.758 0 45.255L466.746 512 319.373 659.373c-12.497 12.496-12.497 32.758 0 45.254C325.621 710.876 333.811 714 342 714s16.379-3.124 22.627-9.373L512 557.254l147.373 147.373C665.621 710.876 673.811 714 682 714s16.379-3.124 22.627-9.373c12.497-12.496 12.497-32.758 0-45.254L557.254 512z"
            fill="#757e8d"
            p-id="2133"
          />
        </svg>
      </div>
      <div class="lt">
        <div class="fz_jut">
          <div class="fz_name">预约成功后</div>
          <div class="fz_tit">我们将会提供</div>
          <div class="nei">
            <div class="li">
              <i>
                <img
                  :src="require('@/assets/altProduct/alticonimg.png')"
                  alt=""
                />
              </i>
              <span>安排专业团队免费上门咨询需求</span>
            </div>
            <div class="li">
              <i>
                <img
                  :src="require('@/assets/altProduct/alticonimg.png')"
                  alt=""
                />
              </i>
              <span>根据企业实际情况提供合理解决方案</span>
            </div>
            <div class="li">
              <i>
                <img
                  :src="require('@/assets/altProduct/alticonimg.png')"
                  alt=""
                />
              </i>
              <span>7*24小时在线解答您的疑问</span>
            </div>
            <div class="li">
              <i>
                <img
                  :src="require('@/assets/altProduct/alticonimg.png')"
                  alt=""
                />
              </i>
              <span>专业的开发团队协助，满足您所有的定制化要求</span>
            </div>
          </div>
        </div>
      </div>
      <div class="gt">
        <div class="fz_jut">
          <div class="title">预约产品演示</div>
          <div class="text">提交信息后，专属顾问将会在1个工作日内与您联系</div>
          <el-form ref="form" :model="form">
            <el-form-item>
              <el-input v-model="form.name" placeholder="姓名" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.corporate" placeholder="公司名称" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.tel" placeholder="手机号" />
              <div v-if="!isGetting" class="code-button" @click="getCode">
                获取验证码
              </div>
              <div v-else class="code-button getting">
                {{ timing + 's后重新获取' }}
              </div>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.code" placeholder="输入验证码" />
            </el-form-item>
          </el-form>
          <div class="product-list-wrap">
            <div class="wrap-text">选择您想演示的产品</div>
            <div class="product-list">
              <div
                v-for="(item, index) in productList"
                :key="index"
                class="product-item"
                @click="onXuanZhong(item)"
              >
                <div
                  class="xuanzhong"
                  :class="{ isxuanzhong: xuanZhong(item) }"
                ></div>
                <div class="item-text">{{ item.text }}</div>
              </div>
            </div>
          </div>
          <div class="fzlat" @click="onQueren">
            <div class="zhengque" :class="{ isqueding: isQueding }"></div>
            <span
              >预约产品演示即代表同意
              <a href="/privacy" target="_blank" class="agreement"
                >《隐私保护协议》</a
              ></span
            >
          </div>
          <div class="btn" @click="submit">确认提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSmsCode, checkCode, submitFormData } from '@/api/content'
export default {
  name: 'AltProduct',
  data() {
    return {
      isbealter: false,
      isGetting: false,
      timing: 60,
      form: {
        name: '',
        corporate: '',
        tel: '',
        code: ''
      },
      productIndex: [],
      productList: [
        {
          id: 0,
          text: '战略组织'
        },
        {
          id: 1,
          text: '员工管理'
        },
        {
          id: 2,
          text: '考勤工时'
        },
        {
          id: 3,
          text: '薪酬福利'
        },
        {
          id: 4,
          text: '人才招聘'
        },
        {
          id: 5,
          text: '人才培育'
        },
        {
          id: 6,
          text: '绩效激励'
        },
        {
          id: 7,
          text: '人才发展'
        }
      ],
      isQueding: false
    }
  },
  methods: {
    tobealter() {
      this.isbealter = true
    },
    hideBealter() {
      this.isbealter = false
    },
    getCode() {
      var params = { telephone: this.form.tel }
      getSmsCode(params).then(res => {
        if (res.code === 200) {
          this.isGetting = true
          var time = setInterval(() => {
            this.timing -= 1
            if (this.timing === 0) {
              clearInterval(time)
              this.timing = 60
              this.isGetting = false
            }
          }, 1000)
        }
      })
    },
    onXuanZhong(item) {
      var index = this.productIndex.indexOf(item.text)
      if (index === -1) {
        this.productIndex.push(item.text)
      } else {
        this.productIndex.splice(index, 1)
      }
    },
    xuanZhong(item) {
      var index = this.productIndex.indexOf(item.text)
      if (index === -1) {
        return false
      } else {
        return true
      }
    },
    onQueren() {
      this.isQueding = !this.isQueding
    },
    submit() {
      if (!this.form.name) {
        this.$message.error('姓名不能为空')
      } else if (!this.form.corporate) {
        this.$message.error('公司名称不能为空')
      } else if (!this.form.tel) {
        this.$message.error('手机号不能为空')
      } else if (this.productIndex.length === 0) {
        this.$message.error('请选择演示的产品')
      } else {
        if (this.isQueding) {
          const data = { telephone: this.form.tel, code: this.form.code }
          checkCode(data)
            .then(res => {
              if (res.code === 200) {             
                const formData = {
                  name: this.form.name,
                  fullname: this.form.corporate,
                  tel: this.form.tel,
                  pro: this.productIndex.join(',')
                }
                // console.log(formData)
                // return
                submitFormData(formData).then(rrs => {
                  if (rrs.error == 0) {
                    this.hideBealter()
                    setTimeout(() => {
                      alert('已成功提交')
                      this.form = {
                        name: '',
                        corporate: '',
                        tel: '',
                        code: ''
                      }
                      this.productIndex = []
                    }, 100)
                  }
                })
              }
            })
            .catch(error => {
              this.$message.error('验证码错误，请重新输入')
            })
        } else {
          alert('请先同意隐私协议')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bealter {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  .bag {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }
  .cont {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    display: flex;
    background-color: #f8f8f8;
    width: 910px;
    height: 712px;
    border-radius: 8px;
    .close {
      width: 30px;
      height: 30px;
      position: absolute;
      right: 35px;
      top: 35px;
      cursor: pointer;
      z-index: 9999;
    }
    .lt {
      background: url('@/assets/altProduct/yanshiltimg.png') no-repeat;
      background-position: center;
      background-size: cover;
      width: 41.17%;
      padding-top: 11rem;
      box-sizing: border-box;
      .fz_jut {
        width: 100%;
        padding: 0 3rem;
        box-sizing: border-box;
        .fz_name {
          font-size: 16px;
          font-family: OPPOSans-M;
          color: #737c8b;
          margin-bottom: 13px;
          line-height: 1;
        }
        .fz_tit {
          font-size: 32px;
          font-family: OPPOSans-M;
          color: #181818;
          line-height: 1;
          margin-bottom: 40px;
        }
        .nei {
          width: 100%;
          .li {
            display: flex;
            align-items: flex-start;
            margin-bottom: 2rem;
            i {
              width: 20px;
              height: 20px;
              margin-right: 6px;
              img {
                display: block;
              }
            }
            span {
              font-size: 16px;
              font-family: OPPOSans-M;
              color: #566379;
            }
          }
        }
      }
    }
    .gt {
      flex: 1;
      position: relative;
      .fz_jut {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 70px 70px 0;
        .title {
          font-size: 32px;
          color: #181818;
          font-family: OPPOSans-M;
          line-height: 1;
          margin-bottom: 14px;
        }
        .text {
          font-size: 16px;
          font-family: OPPOSans-M;
          color: #737c8b;
          line-height: 1;
          margin-bottom: 40px;
        }
        .code-button {
          cursor: pointer;
          width: 120px;
          height: 40px;
          margin-left: 10px;
          border: 1px solid #dee0e3;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
          font-family: OPPOSans-R;
          color: #181818;
          border-radius: 4px;
          box-sizing: border-box;
        }
        .getting {
          background-color: #e0e5f0;
          border: 1px solid #e0e5f0;
          color: #8893a9;
        }
        .code-button:hover {
          border: solid 1px #3577ea;
          color: #3577ea;
        }
        .getting:hover {
          border: 1px solid #e0e5f0;
          color: #8893a9;
        }
        .product-list-wrap {
          width: 100%;
          margin-bottom: 22px;
          border-bottom: 1px solid #e8eaed;
          .wrap-text {
            font-size: 13px;
            font-family: OPPOSans-R;
            color: #737c8b;
            margin-bottom: 20px;
          }
          .product-list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-start;
            .product-item {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              margin-right: 77px;
              margin-bottom: 24px;
              cursor: pointer;
              .xuanzhong {
                width: 16px;
                height: 16px;
                background-color: #fff;
                border-radius: 4px;
                border: 1px solid #dee0e3;
                background-repeat: no-repeat;
                background-position: center;
                transition: all 0.3s ease-in-out;
                box-sizing: border-box;
                margin-right: 8px;
              }
              .isxuanzhong {
                background-image: url('@/assets/altProduct/zhengque.png');
                background-color: #3577ea;
                border-color: #3577ea;
              }
              .item-text {
                font-family: OPPOSans-R;
                font-size: 14px;
                color: #181818;
                line-height: 1;
              }
            }
            .product-item:nth-child(3n) {
              margin-right: 0;
            }
          }
        }
        .fzlat {
          display: flex;
          align-items: center;
          justify-content: center;
          .zhengque {
            width: 16px;
            height: 16px;
            background-color: #fff;
            border-radius: 4px;
            border: 1px solid #dee0e3;
            background-repeat: no-repeat;
            background-position: center;
            transition: all 0.3s linear;
            cursor: pointer;
          }
          span {
            padding-left: 10px;
            // display: block;
            font-size: 12px;
            color: #737c8b;
            .agreement {
              color: #3577ea;
            }
          }
          .isqueding {
            background-image: url('@/assets/altProduct/zhengque.png');
            background-color: #3577ea;
            border-color: #3577ea;
          }
        }
        .btn {
          margin-top: 10px;
          width: 100%;
          height: 40px;
          background-color: #3577ea;
          border-radius: 4px;
          line-height: 40px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }
        ::v-deep .el-form-item {
          .el-form-item__content {
            display: flex;
            .el-input {
              flex: 1;
            }
            .el-select {
              flex: 1;
            }
          }
        }
      }
    }
  }
}
</style>
